module.exports = __webpack_public_path__ + "static/img/twelve.98264beb.svg";